function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a-16",
  d: "M-22 2.24H20V22H-22z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b-15"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a-16",
  overflow: "visible"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#b-15)",
  d: "M16.543,8.028c-0.023,1.503-0.523,3.538-2.867,4.327c0.734-1.746,0.846-3.417,0.326-4.979 c-0.695-2.097-3.014-3.735-4.557-4.627C8.918,2.443,8.242,2.823,8.252,3.432c0.02,1.112-0.318,2.737-1.959,4.378 C4.107,9.994,3,12.251,3,14.517C3,17.362,5,21,9,21c-4.041-4.041-1-7.483-1-7.483C8.846,19.431,12.988,21,15,21 c1.711,0,5-1.25,5-6.448c0-3.133-1.332-5.511-2.385-6.899C17.268,7.195,16.551,7.455,16.543,8.028"
});

function SvgHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 507,
    height: 507,
    viewBox: "0 0 507.289 507.289",
    style: {
      enableBackground: "new 0 0 507.289 507.289"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.4d06081e.svg";
export { ForwardRef as ReactComponent };